import axios from 'axios';

// Step 1: Fetch access token
const fetchAccessToken = async () => {
  const response = await axios.post('https://www.onemap.gov.sg/api/auth/post/getToken', {
    email: `${process.env.REACT_APP_ONE_MAP_EMAIL}`,
    password: `${process.env.REACT_APP_ONE_MAP_PASSWORD}`
  });

  const { access_token, expiry_timestamp } = response;

  localStorage.setItem('oneMapAccessToken', access_token);
  localStorage.setItem('oneMapExpiryTimestamp', expiry_timestamp);

  return access_token;
};

// Step 2: Use token to call search API
export const fetchOneMapData = async (addressField) => {
  try {
    let accessToken = localStorage.getItem("oneMapAccessToken");
    let expiryTimestamp = localStorage.getItem("oneMapExpiryTimestamp");

    const currentUnixTimestamp = Math.floor(Date.now() / 1000); // current time in seconds

    if (!accessToken || !expiryTimestamp || currentUnixTimestamp >= parseInt(expiryTimestamp)) {
      // Token is missing or expired
      accessToken = await fetchAccessToken();
    }

    const mapData = await axios.get(
      `https://www.onemap.gov.sg/api/common/elastic/search?searchVal=${addressField}&returnGeom=Y&getAddrDetails=Y&pageNum=1`,
      {
        headers: {
          Authorization: accessToken,
        },
      }
    );

    return mapData;
  } catch (error) {
    console.error('Error fetching OneMap data:', error.response?.data || error.message);
    throw error;
  }
};
